module.exports = __webpack_public_path__ + "img/ic_plus_grey.a3b34513.svg";